import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import {CircularProgress} from '@material-ui/core'
import {Query} from 'react-apollo'
import {get, isEmpty, pullAllBy} from 'lodash'
import {SEARCH_PRODUCTS_BY_PRODUCT_CODE} from '../../../../../../graphql/query'
import {NO_IMAGE_AVAL_SRC} from '../../../../../../constant'

const Root = styled.div`
  .react-autosuggest__container {
    position: relative;
    flex-grow: 1;
    min-width: 300px;
  }
  .react-autosuggest__input {
    width: 300px;
    height: 30px;
    padding: 10px 20px;
    border: 1px solid #aaa;
    border-radius: 4px;
  }

  .react-autosuggest__input--focused {
    outline: none;
  }

  .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .react-autosuggest__suggestions-container {
    display: none;
    bottom: 0;
    height: 350px;
  }

  .react-autosuggest__suggestions-container--open {
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1;
    top: 43px;
    width: 300px;
    border: 1px solid #aaa;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    max-height: 250px;
    overflow-y: auto;
    justify-content: center;
  }

  .react-autosuggest__suggestions-list {
    padding: 5px;
    width: 300px;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 5px 10px;
    list-style: none;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }

  .circle-dude {
    color: #663ee8;
  }
`

const renderSuggestion = suggestion => {
  return (
    <span style={{display: 'flex', flexDirection: 'row'}}>
      <img
        style={{width: 64, height: 64}}
        alt=""
        src={suggestion.image.src ? suggestion.image.src : NO_IMAGE_AVAL_SRC}
      />
      <div style={{flexDirection: 'column', paddingLeft: 10, paddingTop: 2, paddingBottom: 2, fontSize: 13}}>
        {suggestion.productCode}
        <div style={{flexDirection: 'row', fontWeight: '500'}}>{`${get(suggestion, 'product.name')} `}</div>
        <div style={{flexDirection: 'row', color: '#aeafb7', fontSize: 12}}>
          ({suggestion.productType
            .map(type => {
              return type.value
            })
            .join(', ')})
        </div>
      </div>
    </span>
  )
}

class SearchSKU extends React.Component {
  constructor() {
    super()

    this.state = {
      value: '',
      searchQuery: '',
    }
    this.timeOut = null
    this.suggestionWrapper = null
  }

   onLoadRef(outerRef) {
    const that = this
    return function ref(ele) {
      if (ele != null) {
        outerRef(ele)
        that.suggestionWrapper = ele
      }
    }
  }

  onChange = (event, {newValue}) => {
    this.setState({
      value: newValue,
    })
  }

  getSuggestionValue = suggestion => {
    this.props.onSelectSKU(suggestion)
    return ''
  }

  onSuggestionsClearRequested = () => {}

  onSuggestionsFetchRequested = ({ value }) => {
    clearTimeout(this.timeOut)
    this.timeOut = setTimeout(() => {
      this.setState({ searchQuery: value })
      this.timeOut = null
      this.suggestionWrapper.scrollTop = 0
    }, 500)
  }

  formatSKUData = sku => {
    const fallbackProductImage = get(sku, 'productImages.0.src', '')
    const skuImage = get(sku, 'image.src', '')
    if (isEmpty(skuImage)) {
      sku.image.src = isEmpty(get(sku, 'productType', [])) ? fallbackProductImage : ''
    }
    sku.product = {name: sku.productName}
    return {...sku}
  }

  loadMoreSKU = ({offset, fetchMore}) => {
    fetchMore({
      variables: {
        offset,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        return Object.assign({}, prev, {
          searchSKUs: [...prev.searchSKUs, ...fetchMoreResult.searchSKUs],
        })
      },
    })
  }

  render() {
    const {value} = this.state
    const inputProps = {
      placeholder: 'Search by product name or code',
      value,
      onChange: this.onChange,
    }
    return (
      <Root>
        <Query
          query={SEARCH_PRODUCTS_BY_PRODUCT_CODE}
          variables={{ projectId: this.props.projectId, searchQuery: this.state.searchQuery, isFree: !!this.props.isFree }}
        >
          {({loading, error, data, fetchMore}) => {
            const renderSuggestionsContainer = ({containerProps, children}) => {
              const { ref, ...restContainerProps } = containerProps
              return (
                <div
                  onScroll={e => {
                    if ((e.target.scrollHeight - e.target.scrollTop <= 250)
                      && !loading && (data.searchSKUs.length !== 0)
                    ) {
                      this.loadMoreSKU({
                        offset: data.searchSKUs.length,
                        fetchMore,
                      })
                    }
                  }}

                  ref={this.onLoadRef(ref)}
                  {...restContainerProps}
                >
                  {children}
                  {loading && (
                    <CircularProgress
                      size={32}
                      style={{margin: 10}}
                      color="primary"
                      classes={{
                        colorPrimary: 'circle-dude',
                      }}
                    />
                  )}
                </div>
              )
            }

            const suggestionDatas = pullAllBy(
              (data.searchSKUs || []).map(this.formatSKUData),
              this.props.selectedItemIDs.map(item => ({id: item})),
              'id',
            )

            return (
              <div style={{display: 'flex', alignItems: 'baseline'}}>
                <Autosuggest
                  suggestions={suggestionDatas}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={renderSuggestion}
                  renderSuggestionsContainer={renderSuggestionsContainer}
                  inputProps={inputProps}
                />
                <span style={{
                  color: '#aeafb7',
                  fontStyle: 'italic',
                  fontSize: '12px',
                  marginLeft: '10px',
                  }}
                >
                  {this.props.remark}
                </span>
              </div>
            )
          }}
        </Query>

      </Root>
    )
  }
}

SearchSKU.propTypes = {
  projectId: PropTypes.string.isRequired,
  onSelectSKU: PropTypes.func.isRequired,
  selectedItemIDs: PropTypes.array,
  isFree: PropTypes.bool,
  remark: PropTypes.string,
}

SearchSKU.defaultProps = {
  selectedItemIDs: [],
  remark: '',
  isFree: false,
}

export default SearchSKU



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/components/SearchSKU.js